import { ActionIcon, Text, Flex } from '@mantine/core';
import { IconSquarePlus } from '@tabler/icons-react';
import { modals } from '@mantine/modals';

import { useShopBalance } from '../hooks/use-shop-balance';
import { AddShopCurrencyForm } from './add-shop-currency-form';

import type { TShop, TShopBalance } from '../store/types';

type Props = {
  shop: TShop;
  withAddBtn?: boolean;
  notZeroBalances?: boolean;
};

export const ShopBalance = (props: Props) => {
  const {
    shop,
    withAddBtn = true,
    notZeroBalances = false,
  } = props;

  const {
    currencies,
    balances,
    handleAddShopCurrency,
  } = useShopBalance({ shop });

  const openAddCurrencyModal = () => modals.open({
    title: `Добавление валюты магазину с ID ${shop.id}`,
    centered: true,
    children: (
      <AddShopCurrencyForm
        currencies={currencies}
        shop={shop}
        onSubmit={handleAddShopCurrency}
        onClose={modals.closeAll}
      />
    ),
  });

  if (!balances) {
    return (
      <Text>Нет данных</Text>
    );
  }

  const getNotZeroBalances = (items: TShopBalance[]): TShopBalance[] => {
    return items.filter((item) => Number(item.balance) !== 0);
  };

  const showedBalances = notZeroBalances ? getNotZeroBalances(balances) : balances;

  return (
    <Flex justify={'space-between'} align={'center'} w={'100%'}>
      <Flex justify={'flex-start'} align={'center'} wrap={'wrap'}>
        {showedBalances.map((item, index) => (
          <span key={item.currency}>
            <b><span>{item.currency}</span>:&nbsp;</b>
            <span>{item.balance}</span>{index < showedBalances.length - 1 && (<span>,</span>)}&nbsp;
          </span>
        ))}
      </Flex>

      {withAddBtn && (
        <ActionIcon variant="subtle" onClick={openAddCurrencyModal}>
          <IconSquarePlus size={16} />
        </ActionIcon>
      )}
    </Flex>
  );
};
